import { render } from "./ListadoNotificaciones.vue?vue&type=template&id=4fb85669&scoped=true"
import script from "./ListadoNotificaciones.vue?vue&type=script&lang=js"
export * from "./ListadoNotificaciones.vue?vue&type=script&lang=js"

import "./ListadoNotificaciones.vue?vue&type=style&index=0&id=4fb85669&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fb85669"]])

export default __exports__